import Grid from '@blocks/Grid'
import { Box, Container } from '@styles/helpers'
import { useAppStateContext } from '@contexts/app'
import { tablet } from '@styles/mixins'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import AuthFooter from './components/AuthFooter'
import AuthSocial from './components/AuthSocial'
import AuthTemplateContext from './context'

export default function AuthTemplate({ children }: Props) {
    const { title } = useAppStateContext()
    const [footer, setFooter] = useState<React.ReactNode>()
    const [description, setDescription] = useState<React.ReactNode>()
    const [isSocial, setIsSocial] = useState<boolean>()

    return (
        <AuthTemplateContext.Provider value={{ 
            footer, setFooter, isSocial, setIsSocial, description, setDescription 
        }}>
            <AuthWrapper>
                <FormBox>
                    <Grid>
                        <Grid gap="10px">
                            <h1 className="h2">{title}</h1>
                            {description && <p>{description}</p>}
                        </Grid>
                        <AuthSocial />
                        <Grid gap="20px">
                            {children}
                        </Grid>
                        <AuthFooter />
                    </Grid>
                </FormBox>
            </AuthWrapper>
        </AuthTemplateContext.Provider>
    )
}

// STYLES
const AuthWrapper = styled(Container)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding-top: 30px;
    padding-bottom: 30px;
`

const FormBox = styled(Box)`
    width: 100%;

    ${tablet(css`
        width: 550px;
    `)}
`

// TYPES
interface Props {
    children: React.ReactNode
}